import React from 'react';
import PropTypes from 'prop-types';
import { Card, Select } from 'modules/common';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

export const DECLINE_VALUE_OPTIONS = [
  'Decline',
  'Skip',
  'Not This Time',
  'No Additional Donation',
  'Pass',
  'No Thanks',
].map(value => ({ value, label: value }));

function DeclineValue({ editedUpsell, onUpdateEditedUpsell, className, subtitle }) {
  const selectedOption = DECLINE_VALUE_OPTIONS.find(option => option.value === editedUpsell.decline) || null;

  return (
    <Row className={className}>
      <Col sm={12} md={12}>
        <Card.Title subtitle={subtitle}>Decline Button Text</Card.Title>
        <Select
          name="decline"
          label="Decline Button Text"
          isSearchable={false}
          numberOfDropdownItems={DECLINE_VALUE_OPTIONS.length}
          disabled={editedUpsell._isDisabled}
          value={selectedOption}
          options={DECLINE_VALUE_OPTIONS}
          onChange={onUpdateEditedUpsell}
          placeholder="Select decline button text..."
          validators={['required']}
          errorMessages={['Decline Button Text is required.']}
        />
      </Col>
    </Row>
  );
}

DeclineValue.propTypes = {
  editedUpsell: PropTypes.object.isRequired,
  onUpdateEditedUpsell: PropTypes.func.isRequired,
  className: PropTypes.string,
  subtitle: PropTypes.string,
};

DeclineValue.defaultProps = {
  className: '',
  subtitle: 'Choose the copy for the decline upsell button.',
};

export default DeclineValue;
